import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import AppConstatnts from "../../../common/AppConstants";
import AppDataContext from "../../../common/appContext";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";
import { getInputBox } from "../../../sharedComponents/formFields/LabelInFormFields";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";

const UpdateAgentDetails = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  setAlert,
  setAlertType,
  setAlertMessage,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    email: "",
    eventId: eventId,
    id: 0,
    mode: null,
    name: "",
    phone: "",
    playerEmail: "",
    playerID: playerID,
    playerNumber: "",
    userBy: user?.loginID,
  };
  const defaultErrors = {
    email: false,
    playerEmail: false,
  };
  const defaultErrorMsg = {
    email: "",
    playerEmail: "",
  };
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [agentGridData, setAgentGridData] = useState([]);
  const [agentFormData, setAgentFormData] = useState(formData);
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(-1);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );

  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "name",
      headerName: "Agency Name/Agent",
      width: 200,
      flex: columnFlex,
    },
    {
      field: "phone",
      headerName: "Agent Phone",
      width: 200,
      flex: columnFlex,
    },
    {
      field: "email",
      headerName: "Agent Email",
      width: 250,
      flex: columnFlex,
    },
    // {
    //   field: "playerNumber",
    //   headerName: "Player Number",
    //   width: 150,
    //   flex: columnFlex,
    // },
    // {
    //   field: "playerEmail",
    //   headerName: "Player Email",
    //   width: 180,
    //   flex: columnFlex,
    // },
  ];

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    setAgentGridData(gridPropsData);
    setAgentFormData(formData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  //if any one of the input is not empty, save is enabled
  const checkIfSaveBtnDisabled = () => {
    return agentFormData.name || agentFormData.phone || agentFormData.email
      ? false
      : true;
  };

  //before submiting, check for valid email
  const validateErros = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  //---HANDLERS---

  //single handler for open and close dialog box
  const handleOpenCloseConfirmationBox = (val) => {
    if (val == false) {
      setDeleteRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. set state of agent Id to delete
  //2. open the confirmation dialog box
  const handleRowDeleteClick = (id) => {
    setDeleteRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //1. look for agent details to edit from grid Data
  //2. fills the input boxes with agent details to edit
  const handleRowEditClick = (id) => {
    setIsUpdate(true);
    resetError();
    let result = agentGridData.find((a, i) => {
      return a.id === id;
    });
    setAgentFormData({ ...result, userBy: user?.loginID });
  };

  //1. common event handler for input changes.
  //2. switch case, only look for input box changed based on key.
  //3. extra cases added, in case in future those input boxes are enabled.
  const handleInputChange = (e, key) => {
    let finalValue = e.target.value;
    switch (key) {
      case "playerEmail":
      case "email":
        if (
          finalValue &&
          !finalValue.toLowerCase().match(AppConstatnts.VALIDATIONS.EMAIL_REGEX)
        ) {
          toggleError(key, true, "Invalid email.");
        } else toggleError(key, false, "");
        break;
      case "playerNumber":
        finalValue = e.target.value?.replace(
          AppConstatnts.VALIDATIONS.NO_LETTERS_OR_SPECIAL_CHARS,
          ""
        );
        break;
    }
    setAgentFormData({
      ...agentFormData,
      [key]: finalValue || null,
    });
  };

  //on cancel, the agent form details are emptied or reset
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setAgentFormData(formData);
  };

  //1. check validation
  //2. call the api to save in DB
  //3. after save reset all possible values
  const handleSaveClick = () => {
    if (!checkIfSaveBtnDisabled() && validateErros()) {
      const result = handleSubmit(agentFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. call the api to delete in DB
  //4. after delete reset all possible values
  const handleDeleteClick = () => {
    let record = agentGridData.find((a, i) => {
      return a.id === deleteRowId;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(true, "success", "Agent record deleted Successfully.");
      }
    }
  };

  //---APIs---

  //to create, update and delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result = await PlayerProfileService.insertUpdatePlayerAgentDetails(
        formData
      );
      if (result) {
        getUpdatedAgentGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedAgentGridData = async () => {
    try {
      const playerResponse = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setAgentGridData(playerResponse.data.agent);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.gridSectionTitle}
            >
              Agent Details
            </Typography>
          </Grid>
          <Grid
            item
            lg={2}
            md={2}
            sm={2}
            xs={2}
            className={classes.inputSectionPadding}
          >
            <Box>
              {isUpdate ? (
                <TitleTooltip title="cancel">
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <CancelOutlinedIcon
                      sx={{ color: styles.cancelButton.cancelIconColor }}
                    />
                  </Button>
                </TitleTooltip>
              ) : (
                ""
              )}
              <TitleTooltip title="Save agent details">
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveClick}
                >
                  <SaveOutlinedIcon />
                </Button>
              </TitleTooltip>
            </Box>
          </Grid>
        </Grid>
        <Grid
          key={0}
          container
          pl={2}
          pr={2}
          spacing={2}
          justifyContent={"start"}
        >
          <Grid item lg={2.5} md={6} sm={12} xs={12}>
            {getInputBox("Agency Name/Agent", agentFormData.name, (e) => {
              handleInputChange(e, "name");
            })}
          </Grid>
          <Grid item lg={2} md={6} sm={12} xs={12}>
            {getInputBox(
              "Agency Phone",
              agentFormData.phone,
              (e) => handleInputChange(e, "phone"),
              false,
              "tel"
            )}
          </Grid>
          <Grid item lg={2} md={6} sm={12} xs={12}>
            {getInputBox(
              "Agency Email",
              agentFormData.email,
              (e) => handleInputChange(e, "email"),
              false,
              "text",
              error.email
              // errorMessage.email
            )}
          </Grid>
          {/* <Grid item lg={3} md={6} sm={12} xs={12}>
            {getInputBox("Player Number", agentFormData.playerNumber, (e) => {
              handleInputChange(e, "playerNumber");
            })}
          </Grid>
          <Grid item lg={2.5} md={6} sm={12} xs={12}>
            {getInputBox(
              "Player Email",
              agentFormData.playerEmail,
              (e) => handleInputChange(e, "playerEmail"),
              false,
              "text",
              error.playerEmail,
              errorMessage.playerEmail
            )}
          </Grid> */}
        </Grid>
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={agentGridData}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => {
              handleOpenCloseConfirmationBox(false);
            }}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};

export default React.memo(UpdateAgentDetails);
